import {Button} from '@primer/react'
import {Link} from '@github-ui/react-core/link'
import {DockedPanel, useDockedPanelActions, type PanelMetadata} from '../../../contexts/DockedPanelContext'
import {useRef} from 'react'

export type ActionConfig =
  | {linkTo: string; label: string}
  | {onClick: () => void; label: string}
  | {panel: DockedPanel; label: string; metadata?: PanelMetadata}

export function Action({action}: {action: ActionConfig}) {
  if ('linkTo' in action) {
    return (
      <Button as={Link} to={action.linkTo} variant="invisible" size="small">
        {action.label}
      </Button>
    )
  }

  if ('panel' in action) {
    return <DockedPanelAction action={action} />
  }

  return (
    <Button type="button" variant="invisible" size="small" onClick={action.onClick}>
      {action.label}
    </Button>
  )
}

// Separate component for panel actions to manage focus return after closing the panel
function DockedPanelAction({action}: {action: Extract<ActionConfig, {panel: string}>}) {
  const {openPanel} = useDockedPanelActions()
  const ref = useRef<HTMLButtonElement>(null)

  return (
    <Button
      type="button"
      variant="invisible"
      size="small"
      onClick={() => openPanel(action.panel, {metadata: action.metadata, returnFocusTo: ref.current ?? undefined})}
      ref={ref}
    >
      {action.label}
    </Button>
  )
}
